import React, { useEffect, useState } from 'react'
import { getRandomCotation } from 'utils/methods/math';
import styled, { keyframes } from 'styled-components';
import COLOR from 'utils/constants/color';
import { useUI } from 'store/UI/selectors';

const btnpurple = "rgba(86,29,223)"
let phrase_change_interval = null;
const QuetaArea = styled.div`
    // background: #3c1262;
    background-image: linear-gradient(to right, #510a49, #042f72) !important;
    width: auto;
    margin: 0 auto;
    text-align: center;
    padding: 12px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 149x;
    border-radius: 56px;
`;
const TextContainer = styled.div`
    display: flex;
    flex-direction:column;
    justify-content:center;
    align-items: flex-end;
    width: 100%;
    padding: 0px 16px;
`;
const MessageWrapper = styled.div`
    max-width:450px;
    padding: 10px;
`
const TextMessage = styled.span`
    color:#fff;
    font-size: 18px;
    font-weight: 600;

    @media (max-width: 992px) {
        font-size: 14px;
    }
`;
const TextAuthor = styled.span`
    color:#fff;
    font-size: 14px;
    font-weight: 400;
    align-self: center;
    text-align: right;
    background-color: ${btnpurple};
    border-radius: 12px;
    padding: 2px 24px;
    margin-top:10px;
    min-width:100px;
    `;

    const bounce = keyframes`
    to {
        opacity: 0.3;
        transform: translate3d(0, -1rem, 0);
    }
`;

const Container = styled.div`
    margin-top: ${p => p.mounted ? '0px' : '24px'};
    opacity: ${p => p.mounted ? 1 : 0};
    transition: all 300ms ease;
    transition-delay: ${p => p.delay && `${p.delay}ms`};
`;

const Loading = styled.div`
    display: flex;
    justify-content: center;
`;

const Circle = styled.div`
    width: 1rem;
    height: 1rem;
    margin: 2rem 0.3rem;
    background: ${COLOR.green100};
    border-radius: 50%;
    animation: 0.6s ${bounce} infinite alternate;

    &:nth-child(2) {
        animation-delay: 0.2s;
    }

    &:nth-child(3) {
        animation-delay: 0.4s;
    }
`;

export const Wrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export default function PhraseLoader() {
     const { quotesData = [] } = useUI();
    const [quatation, setQuatation] = useState(getRandomCotation(quotesData));

    useEffect(() => {
        if (phrase_change_interval) {
            clearInterval(phrase_change_interval);
        }
        phrase_change_interval = setInterval(() => {
            setQuatation(getRandomCotation(quotesData))
        }, 6000);
        return () => clearInterval(phrase_change_interval);
    }, [])
    return (
        <Wrapper>
            <Container mounted={true} delay={500}>
            <img alt='logo' style={{ height: '160px' }} src={'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2FLOGO.png?alt=media&token=6a9a7f5a-4959-431c-a305-8eabe60a4d46'}></img>
            </Container>
            <QuetaArea>
                <TextContainer smallmsg={quatation?.size === "sml"} longAuthor={quatation?.author === "Selena Quintanilla-Pérez, cantante y compositora"}>
                    <MessageWrapper>
                        <TextMessage className='animate__animated animate__pulse'>{quatation?.message}</TextMessage>
                    </MessageWrapper>
                    {quatation?.author && <TextAuthor longAuthor={quatation?.author === "Selena Quintanilla-Pérez, cantante y compositora"} >- {quatation?.author}</TextAuthor>}
                </TextContainer>
            </QuetaArea>
            <Container mounted={true}>
                <Loading>
                    <Circle></Circle>
                    <Circle></Circle>
                    <Circle></Circle>
                </Loading>
            </Container>
        </Wrapper>
    )
}
